import { withRouter } from "react-router-dom";
import Typewriter from "typewriter-effect";
import { Component } from "react";
import React from "react";

import { frameworksAndLibraries } from "../../shared/constants/landingConstants";
import * as video from "../../public/images/video_HD_compressed.mp4";
import "./landingStyle.scss";

class Landing extends Component {
  redirectOnClick(link) {
    this.props.history.push(link);
  }

  render() {
    return (
      <div className="landing">
        <div className="landing__image">
          <video className="video" loop autoPlay muted src={video}></video>
          <div className="loading__content">
            <div className="landing__link--wrapper">
              <div
                className="landing__link"
                onClick={() => this.redirectOnClick("about-me")}
              >
                <hr className="landing__top__line" />
                <span>about me</span>
              </div>
              <div
                className="landing__link"
                onClick={() => this.redirectOnClick("projects")}
              >
                <hr className="landing__top__line" />
                <span>projects</span>
              </div>
              <div
                className="landing__link"
                onClick={() => this.redirectOnClick("contact-me")}
              >
                <hr className="landing__top__line" />
                <span>contact</span>
              </div>
              <div
                className="landing__link"
                onClick={() => this.redirectOnClick("skills")}
              >
                <hr className="landing__top__line" />
                <span>skills</span>
              </div>
            </div>
            <div className="landing__main__content--wrapper">
              <span className="landing__main__content__name">Vasilache </span>{" "}
              <span className="landing__main__content__surname">Andrei</span>
              <br />
              <span className="landing__main__content__description--wrapper">
                <span className="landing__main__content__description">
                  web developer and coffee addict.
                </span>
              </span>
              <br />
              <Typewriter
                options={{
                  wrapperClassName: "landing__main__content__typewriter",
                  cursorClassName: "landing__main__content__typewriter--cursor",
                  strings: [...frameworksAndLibraries],
                  autoStart: true,
                  cursor: "_",
                  loop: true,
                  changeDelay: 7,
                  changeDeleteSpeed: 1,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Landing);
